import React, { Component } from "react";
import { connect } from "react-redux";
import { Button, Container, Grid, Header, Icon, List, Segment } from "semantic-ui-react";
import { Link } from "react-router-dom";
import { getTranslate } from "react-localize-redux";
import { getUsers } from "../../reducer";
import { loadUsers } from "../../reducer/actions";


class Sites extends Component
{

    componentDidMount() {
        this.props.loadUsers();
    }

    getUserList(){
        return(
                <List divided relaxed>
                    <List.Item key='addUser'>
                      <List.Content floated='right'>
                        <Button as={Link} to={'/admin/users/create'}>{this.props.translate('general.add')}</Button>
                      </List.Content>
                      <List.Icon size='large' name='user' verticalAlign='middle'/>
                      <List.Content>
                        <List.Header>{this.props.translate('admin.user.addNew')}</List.Header>
                      </List.Content>
                    </List.Item>
                    {this.props.users && typeof this.props.users !== 'undefined' && this.props.users.map((user)=>(
                        <List.Item key={user.id}  as={Link} to={'/admin/users/'+user.id}>
                            <List.Icon name='user' size='large' verticalAlign='middle' />
                            <List.Content>
                                <List.Header>{user.name}</List.Header>
                            </List.Content>
                        </List.Item>
                    ))}
                </List>
        );
    }

    render(){
        return(
            <Container text style={{padding: '1em 1em'}}>
                <Header as='h2' icon textAlign='center'>
                  <Icon name='user' circular />
                </Header>
                <Grid
                    textAlign='center'
                    style={{ height: '100%' }}
                    verticalAlign='middle'
                >
                    <Grid.Column width={14}>

                        <div>
                            <Header as='h2' color='teal' textAlign='center'>
                                {this.props.translate('admin.user.label')}
                            </Header>
                            <Segment stacked>
                                {this.getUserList()}
                            </Segment>
                        </div>
                    </Grid.Column>
                </Grid>
            </Container>
        );
    }

}



const mapStateToProps = state => {
    return {
        users: getUsers(state.admin),
        translate: getTranslate(state.localize),
    }
};

const mapDispatchToProps = (dispatch) => {
    return ({
        loadUsers: () => {
            dispatch(loadUsers())
        }
    });
};


function mergeProps(stateProps, dispatchProps, ownProps) {
    return {

        ...stateProps,
        ...ownProps,
        ...dispatchProps,

    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps,
    mergeProps
)(Sites)



// WEBPACK FOOTER //
// ./src/scenes/Admin/scenes/Users/index.js